import { render, staticRenderFns } from "./AttachmentUploaderList.vue?vue&type=template&id=4f0f261e&scoped=true"
import script from "./AttachmentUploaderList.vue?vue&type=script&lang=js"
export * from "./AttachmentUploaderList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentUploaderList.vue?vue&type=style&index=0&id=4f0f261e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f261e",
  null
  
)

export default component.exports